const ACTIONS = {
    GET_DATA_DELIVERY_SUCCESS: 'GET_DATA_DELIVERY_SUCCESS',
    GET_DATA_DELIVERY_ERROR: 'GET_DATA_DELIVERY_ERROR',
    GET_DATA_DELIVERY_WORKSPACE_SUCCESS: 'GET_DATA_DELIVERY_WORKSPACE_SUCCESS',
    GET_DATA_DELIVERY_WORKSPACE_ERROR: 'GET_DATA_DELIVERY_WORKSPACE_ERROR',
    COPY_DELIVERY_SUCCESS: 'COPY_DELIVERY_SUCCESS',
    COPY_DELIVERY_ERROR: 'COPY_DELIVERY_ERROR',
    GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS: 'GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS',
    GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS: 'GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS'
};

const data = [
    {
        item: {
            title: 'ワークスペースタイトル',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            status: '納品済',
            dot: true
        }
    }
];
const header2 = ['タイトル', 'カテゴリー', '対象', '追加日時', '更新日時'];
const table = [
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { action: '/img/ic_copy_svg.svg' },
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { action: '/img/ic_copy_svg.svg' },
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { action: '/img/ic_copy_svg.svg' },
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { action: '/img/ic_copy_svg.svg' },
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { action: '/img/ic_copy_svg.svg' },
        ]
    },
];

export default (state = { data, header2, table }, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_DELIVERY_SUCCESS:
        case ACTIONS.GET_DATA_DELIVERY_WORKSPACE_SUCCESS:
        case ACTIONS.COPY_DELIVERY_SUCCESS:
        case ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS:
        case ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_DATA_DELIVERY_ERROR:
        case ACTIONS.GET_DATA_DELIVERY_WORKSPACE_ERROR:
        case ACTIONS.COPY_DELIVERY_ERROR:
        case ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ERROR:
        case ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ID_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};